import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Image, SimpleGrid, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {Link as RouteLink} from 'react-router-dom'

const Iconbox = ({iconUrl, title, subtitle, ctaUrl, ctaLabel, isAbsolute}) => {
    const styles = useMultiStyleConfig('Iconbox')
    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: ctaUrl,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: RouteLink,
              to: ctaUrl,
          }

    return (
        <SimpleGrid {...styles.iconboxCard}>
            {iconUrl && <Image src={iconUrl} alt={title} {...styles.icon} />}
            <Flex {...styles.contentWrapper}>
                <Text {...styles.title}>{title}</Text>
                {subtitle && <Text {...styles.subtitle}>{subtitle}</Text>}
            </Flex>
            <Button variant="text-button" {...buttonProps}>
                {ctaLabel}
            </Button>
        </SimpleGrid>
    )
}

Iconbox.displayName = 'Iconbox'

Iconbox.propTypes = {
    iconUrl: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    ctaUrl: PropTypes.string,
    ctaLabel: PropTypes.string,
    isAbsolute: PropTypes.bool,
}

export default Iconbox
